// extracted by mini-css-extract-plugin
export var chip = "_fm-0";
export var filterDropdown = "_fm-5";
export var filterItem = "_fm-6";
export var icon = "_fm-1";
export var removeButton = "_fm-3";
export var removeIcon = "_fm-4";
export var separator = "_fm-2";